<template>
  <div class="map" :id="echartsId"></div>
</template>
<script>
import GLOBAL from '@/api/global_variable'
import chartsView4 from '@/api/charts_view4'
import axios from 'axios'
let router = null
export default {
  data() {
    return {
      ViewData: null,
      echartsMap: null,
      echartsId: 'echars',
      districtsId: '',
    }
  },
  beforeDestroy() {
    if (this.echartsMap) {
      this.echartsMap.clear()
    }
  },
  props: {
    mapId: Number,
  },
  mounted() {
    // this.json = require('../../../static/geo/431000')
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const cityId = sessionStorage.getItem('cityId')
      const regionType = sessionStorage.getItem('regionType')
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
          citytype: regionType,
          cityid: cityId,
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/item/byarea',
      })
        .then((res) => {
          // const cityName = sessionStorage.getItem('cityName')
          // const totalData = GLOBAL.areaData //静态数据
          this.viewData = res.data.result //后台数据
          // for(var i = 0; i < this.viewData.length; i++){
          // }
          // for (var i = 0; i < this.viewData.length; i++) {
          //   for (var j = 0; j < totalData.length; j++) {
          //     if (totalData[j].city === cityName) {
          //       GLOBAL.eTotal = totalData[j].total
          //       // const areaData = totalData[j].area
          //       // for (var k = 0; k < areaData.length; k++) {
          //       //   if (this.viewData[i].groupName === areaData[k].name) {
          //       //     this.viewData[i].eTotalCount = areaData[k].total
          //       //   }
          //       // }
          //     }
          //   }
          // }
          this.initMapData()
        })
        .catch((err) => {})
      //模拟数据
    },
    initMapData() {
      var that = this
      this.echartsId = this.mapId
      router = this.$router
      chartsView4.setEcharts(this.$echarts)

      this.drawMap(this.viewData)
    },

    getJsonAddr(name) {
      if (name === '郴州市') {
        return '431000.json'
      } else if (name === '阜阳市') {
        return '341200.json'
      } else if (name === '临泉县') {
        return '341200-lq.json'
      } else if (name === '清远市') {
        return '441800.json'
      } else if (name === '邵阳市') {
        return '430500.json'
      } else if (name === '太和县') {
        return '341222-th.json'
      } else if (name === '重庆市') {
        return '500000.json'
      } else if (name === '湖南省') {
        return '430000.json'
      } else if (name === '十堰市') {
        return '420300.json'
      } else if (name === '丹江口市') {
        return '420381.json'
      } else if (name === '玉林市') {
        return '450900.json'
      }else {
        return 'china.json'
      }
    },
    drawMap: function (data) {
      // this.axios({
      //   headers: {
      //     orgId: sessionStorage.getItem('orgId')
      //   },
      //   methods: 'get',
      //   url: 'Visual/gateway/byarea'
      // }).then(res => {
      //   cosole.log(res)
      // })
      var s = []
      var geo = chartsView4.mapCenterData()
      // console.log(geo)
      for (var j = 0; j < data.length; j++) {
        const name = data[j].groupName
        if (name) {
          s.push({
            level: 1,
            id: data[j].groupId,
            name: data[j].groupName, //区县名称
            value: data[j].totalFixingCount,
            // lng: geo[name][0], //该曲线对应原定位置
            // lat: geo[name][1],
            itemSize: data[j].totalItemCount, //网关数量
            totalSize: data[j].totalFixingCount, //电梯总数
            isAlert: data[j].totalAlarmCount > 0 ? 1 : 2, //1:有预警显示红色 2:无预警显示蓝色
          })
        }
      }
      const cityName = sessionStorage.getItem('cityName')
      console.log(cityName)
      this.axios
        .get('static/geo/' + this.getJsonAddr(cityName))
        .then((res) => {
          console.log('geo')
          this.$echarts.registerMap(cityName, res.data)
          var div_ = document.getElementById(this.echartsId)
          div_.removeAttribute('_echarts_instance_')
          this.echartsMap = this.$echarts.init(div_)
          console.log(s)
          var option = chartsView4.chartsMap(cityName, s)
          console.log(option)
          this.echartsMap.setOption(option)
          // 防止重复触发点击事件
          if (this.echartsMap._$handlers.click) {
            this.echartsMap._$handlers.click.length = 0
          }

          // 添加事件 会重复注册
          var that = this
          that.echartsMap.on('click', function (params) {
            if (params.data.name) {
              var name = params.data.name
              that.getCityId(name)
              router.push({
                path: '/map',
                query: {
                  name: name,
                  id: params.data.id,
                  lng: params.data.value[0],
                  lat: params.data.value[1],
                },
              })
            }
          })
        })
        .catch((err) => {})
    },
    getCityId: function (name) {
      const data = [
        { id: 1700, name: '北湖区' },
        { id: 1701, name: '苏仙区' },
        { id: 1702, name: '桂阳县' },
        { id: 1703, name: '宜章县' },
        { id: 1704, name: '永兴县' },
        { id: 1705, name: '嘉禾县' },
        { id: 1706, name: '临武县' },
        { id: 1707, name: '汝城县' },
        { id: 1708, name: '桂东县' },
        { id: 1709, name: '安仁县' },
        { id: 1710, name: '资兴市' },
      ]
      data.forEach((item) => {
        if (name == item.name) {
          this.districtsId = item.id
        }
      })
    },
  },
}
</script>
<style>
.map {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/echartsmap/Map.vue